import { render, staticRenderFns } from "./detailSecond.vue?vue&type=template&id=0e37c87f&scoped=true"
import script from "./detailSecond.vue?vue&type=script&lang=js"
export * from "./detailSecond.vue?vue&type=script&lang=js"
import style0 from "./detailSecond.vue?vue&type=style&index=0&id=0e37c87f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e37c87f",
  null
  
)

export default component.exports